import { createContext } from "solid-js";
import { createStore } from "solid-js/store";
import type { Coordinates } from "~/solidJs/shared/helpers/types/ISizeble";
import { OverlayTooltipUI } from "~/solidJs/widgets/OverlayTooltip";
import { CreditsBadgePopoverUI } from "../CreditsBadgePopover";
import { EnumContextMenuPalette } from "../EnumContextMenu";
import { HoverFeatureMenuPalette } from "../HoverFeatureMenu";
import { NodeStyleWidget } from "../NodeStyleWidget/NodeStyleWidget";

type WorkspaceOverlayStore = Coordinates & {
	zoom: number;
};
const [getWorkspaceOverlay, setWorkspaceOverlay] = createStore<WorkspaceOverlayStore>({
	left: 0,
	top: 0,
	zoom: 0.8
});

export const updateTransform = (transform: WorkspaceOverlayStore) => {
	setWorkspaceOverlay(transform);
};

const getWorkspaceOverlayContext = () => {
	return { getWorkspaceOverlay, setWorkspaceOverlay };
};

export const WorkspaceOverlayContext =
	createContext<ReturnType<typeof getWorkspaceOverlayContext>>();

export const WorkspaceOverlayEntity = () => {
	return (
		<div
			style={{
				transform: `scale(${getWorkspaceOverlay.zoom}) translate(${
					getWorkspaceOverlay.left
				}px, ${getWorkspaceOverlay.top}px)`
			}}
			id="workspace-overlay"
			class="pointer-events-none absolute h-full w-full"
		>
			<NodeStyleWidget />
			<CreditsBadgePopoverUI.CreditsBadgePopoverPalette />
			<OverlayTooltipUI.OverlayTooltipPalette />
			<WorkspaceOverlayContext.Provider value={getWorkspaceOverlayContext()}>
				<NodeStyleWidget />
				<EnumContextMenuPalette />
				<HoverFeatureMenuPalette />
			</WorkspaceOverlayContext.Provider>
		</div>
	);
};
